import request from './request'
import { UPLOAD_TYPE, STATUS_CODE } from '@/lib/constants'
class Upload {
  constructor(upload_type, {key_id, resize_width, key_id_sub}) {
    this.form_data = new FormData()
    if (key_id) this.form_data.append('key_id', key_id) // sub디렉토리
    if (key_id_sub) this.form_data.append('key_id_sub', key_id_sub) // sub디렉토리
    if (resize_width) this.form_data.append('resize_width', resize_width) // 이미지 resize

    this.form_param = upload_type // UPLOAD_TYPE에서 넘어오는 값
  }
  append (file_obj) {
    this.form_data.append(this.form_param, file_obj)
  }

  async done (fileInfo, type, key, size) {
    //var percentCompleted = 0;
    
    var config = {
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      },
    };
    
    //s3 upload
    let { data } = await request.post('/upload_s3/img', this.form_data, config);

    if (data.status !== STATUS_CODE.OK){
      return alert(data.msg);
    } else{
      let {resp} = data;
      return resp;
    }
  }
}
export default Upload